import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  helpContentText: {
    defaultMessage: 'Upload a CSV file to import blacklist addresses. Need help formatting? <file>Download our sample CSV file</file>',
    id: 'PFzhyJ',
    description: 'Blacklist Import help content text',
  },
  uploadFile: {
    id: 'OAuPGI',
    defaultMessage: 'Upload File',
    description: 'Title for the first step of the blacklist import process',
  },
});
